import React from "react"
import {Link} from "react-router-dom"
import {clearBuffer, contextMenuOff, getPathAndQueryParams} from "../functions"

export class MenuItemClass extends React.Component {

    render() {

        const {lang, data, removeHandler, copyItemHandler, cutItemHandler, navigate} = this.props

        let pathOpen, pathProperties, pathRename, from
        const l = lang.lang
        const enc = (v) => encodeURIComponent(v || '')

        if (data.item === 'folder') {
            from = `https://${window.location.host}/${l}/folder/open/${data.id}`
            if (data.owner !== data.userId) {
                pathOpen = `/${l}/shared/folder/open/${data.id}`
            } else {
                pathOpen = `/${l}/folder/open/${data.id}`
                pathProperties = `/${l}/folder/detail/${data.id}?thumb=${enc(data.thumb)}`
                pathRename = `/${l}/folder/rename/${data.id}?name=${enc(data.name)}&thumb=${enc(data.thumb)}&parent=${enc(data.parent)}&from=${enc(from)}`
            }
            pathProperties = `/${l}/folder/detail/${data.id}?name=${enc(data.name)}&thumb=${enc(data.thumb)}&parent=${enc(data.parent)}`
        }

        if (data.item === 'link') {
            from = data.link
            pathOpen = data.link
            pathProperties = `/${l}/link/detail/${data.id}?thumb=${enc(data.thumb)}`
            pathRename = `/${l}/link/rename/${data.id}?name=${enc(data.name)}&thumb=${enc(data.thumb)}&parent=${enc(data.parent)}&from=${enc(from)}`
        }

        if (data.item === 'note') {
            from = `https://${window.location.host}/${l}/note/open/${data.id}`
            pathOpen = `/${l}/note/open/${data.id}`
            pathProperties = `/${l}/note/detail/${data.id}?thumb=${enc(data.thumb)}`
            pathRename = `/${l}/note/rename/${data.id}?name=${enc(data.name)}&thumb=${enc(data.thumb)}&parent=${enc(data.parent)}&from=${enc(from)}`
        }

        if (data.item === 'google-folder' || data.item === 'google-file') {
            from = `https://${window.location.host}/${l}/google-drive/open/${data.id}`
            pathOpen = `/${l}/google-drive/open/${data.id}`
            pathProperties = `/${l}/google-drive/detail/${data.id}?thumb=${enc(data.thumb)}&item=${enc(data.item)}`
            pathRename = `/${l}/google-drive/rename/${data.id}?name=${enc(data.name)}&thumb=${enc(data.thumb)}&item=${enc(data.item)}&parent=${enc(data.parent)}&from=${enc(from)}`
        }

        return (
            <>
                <div key={`context-menu-item-${data.key}`} id={`context-menu-item-${data.key}`}
                     className={"context-menu-item d-none"}>
                    <div className={"context-menu-body p-1"}>

                        {/*Поделиться*/}
                        {/*{!data.isShare && <div id={`menu-share-item-${data.key}`}*/}
                        {/*                                className={"item btn btn-light w-100 text-start text-black rounded-0"}>*/}
                        {/*    <Link id={"context-menu-create-link-sharing"}*/}
                        {/*          to={''}*/}
                        {/*          className={'text-decoration-none text-black'}*/}
                        {/*          onClick={() => {*/}
                        {/*              shareHandler(data)*/}
                        {/*          }}>*/}
                        {/*        {lang.body.contextMenu.share}*/}
                        {/*    </Link>*/}
                        {/*</div>}*/}

                        {/*Прекратить делиться*/}
                        {/*{data.isShare && <div id={`menu-stop-share-item-${data.key}`}*/}
                        {/*                       className={"item btn btn-light w-100 text-start text-black rounded-0"}>*/}
                        {/*    <Link id={"context-menu-remove-link-sharing"}*/}
                        {/*          to={''}*/}
                        {/*          className={'text-decoration-none text-black'}*/}
                        {/*          onClick={() => {*/}
                        {/*              shareHandler(data)*/}
                        {/*          }}>*/}
                        {/*        {noShareText}*/}
                        {/*    </Link>*/}
                        {/*</div>}*/}

                        {/*Добавить в избранное*/}
                        {/*{<div id={`menu-move-item-${data.key}`}*/}
                        {/*     className={"item btn btn-light w-100 text-start text-black rounded-0"}>*/}
                        {/*    <Link to={`/${l}/add-to-favorites`}*/}
                        {/*          className={'text-decoration-none text-black'}*/}
                        {/*          rel={"noreferrer noopener"}*/}
                        {/*          onClick={contextMenuOff}>*/}
                        {/*        {'Добавить'}&nbsp;{'в'}&nbsp;{'избранное'}*/}
                        {/*    </Link>*/}
                        {/*</div>}*/}

                        {/*Открыть*/}
                        {data.item === 'link' &&
                        <div id={`menu-open-item-${data.key}`}
                             className={"item btn btn-light w-100 text-start text-black rounded-0"}>
                            <Link to={pathOpen}
                                  className={'text-decoration-none text-black'}
                                  rel={"noreferrer noopener"}
                                  target={"_blank"}
                                  onClick={contextMenuOff}>
                                {lang.body.contextMenu.openItem}
                            </Link>
                        </div>}

                        {/*Открыть*/}
                        {data.item !== 'link' &&
                        <div id={`menu-open-item-${data.key}`}
                             className={"item btn btn-light w-100 text-start text-black rounded-0"}>
                            <Link to={pathOpen}
                                  className={'text-decoration-none text-black'}
                                  onClick={contextMenuOff}>
                                {lang.body.contextMenu.openItem}
                            </Link>
                        </div>}

                        {/*Вырезать*/}
                        {data.from === 'view' &&
                        <div id={`menu-move-item-${data.key}`}
                             className={"item btn btn-light w-100 text-start text-black rounded-0"}
                             onClick={(e) => {
                                 clearBuffer()
                                 copyItemHandler(data)
                                 cutItemHandler(data)
                                 contextMenuOff(e)
                             }}>
                            {lang.body.contextMenu.moveToFolder}
                        </div>}

                        {/*Копировать*/}
                        {data.from === 'view' &&
                        <div id={`menu-copy-item-${data.key}`}
                             className={"item btn btn-light w-100 text-start text-black rounded-0"}
                             onClick={(e) => {
                                 clearBuffer()
                                 copyItemHandler(data)
                                 contextMenuOff(e)
                             }}>
                            {lang.body.contextMenu.copyToFolder}
                        </div>}

                        {/*Свойства*/}
                        <div id={`menu-properties-item-${data.key}`}
                             className={"item btn btn-light w-100 text-start text-black rounded-0"}
                             onClick={() => {
                                 if (data.from === 'search') {
                                     navigate(getPathAndQueryParams(), {replace: true})
                                     // window.location.replace(getPathAndQueryParams())
                                 }
                             }}>
                            <Link to={pathProperties} className={'text-decoration-none text-black'}>
                                {lang.body.contextMenu.propertiesItem}
                            </Link>
                        </div>

                        {/*Переименовать*/}
                        <div id={`menu-rename-item-${data.key}`}
                             className={"item btn btn-light w-100 text-start text-black rounded-0"}
                             onClick={() => {
                                 if (data.from === 'search') {
                                     navigate(getPathAndQueryParams(), {replace: true})
                                 }
                             }}>
                            <Link to={pathRename} className={'text-decoration-none text-black'}>
                                {lang.body.contextMenu.rename}
                            </Link>
                        </div>

                        {/*Удалить*/}
                        {(data.from === 'view' || data.item === 'google-folder' || data.item === 'google-file') &&
                        <div id={`menu-delete-item-${data.key}`}
                             className={"item btn btn-light w-100 text-start text-black rounded-0"}
                             onClick={removeHandler}>
                            {lang.body.contextMenu.deleteItem}
                        </div>}

                    </div>
                </div>
            </>
        )
    }

}